export default __webpack_public_path__ + "static/media/2.99b82100.png";